module.exports = __webpack_public_path__ + "img/status-solid-exceptions.14797df8.svg";